export const LIVE_REFRESH_MS = 60 * 1000;

export const ROBOT_TYPE_SLUG_CC1 = 'cc1';

/** Valor interno do Select múltiplo: alterna marcar / desmarcar todos os CC1. */
export const CC1_ROBOT_FILTER_SELECT_ALL_VALUE = '__ALL_CC1__';

/** Classe no body: esconde header, sidebar, rodapé e título da página (ver _app-layout.scss). */
export const CLEANING_REPORT_DATA_FS_BODY_CLASS =
    'cleaning-report-pluginspace-data-fs';
